import script from "./PositionTransactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./PositionTransactions.vue?vue&type=script&setup=true&lang=ts"

import "./PositionTransactions.vue?vue&type=style&index=0&id=3b73a326&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b73a326"]])

export default __exports__